export default __webpack_public_path__ + "static/media/loginMd.6056fc1e.png";